/** DEPRECATED. This component serves no purpose now that styling has been consolidated within the theme.ts and base-theme.ts */
import { Tooltip as MuiTooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import React from 'react';

const StyledMuiTooltip = styled(MuiTooltip)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {},
}));

type Props = TooltipProps;

const Tooltip: React.FC<Props> = ({ children, placement = 'top', ...props }) => {
  return (
    <StyledMuiTooltip placement={placement} {...props}>
      {/* Box is used to forward refs used by Tooltip in case custom components are passed as children */}
      <Box component="span" sx={{ display: 'block' }}>
        {children}
      </Box>
    </StyledMuiTooltip>
  );
};

export default React.memo(Tooltip);
